import React from "react";
import { Switch, Space, Typography } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
const { Text } = Typography;

export const SelectItem = ({ onChange, disabled, title, text, checked }) => {
	return (
		<Space>
			<Switch
				checkedChildren={<CheckOutlined />}
				unCheckedChildren={<CloseOutlined />}
				checked={checked}
				disabled={disabled}
				onChange={onChange}
			/>
			<Space direction="vertical" size={0}>
				<Text strong>{title}</Text>
				<Text>{text}</Text>
			</Space>
		</Space>
	);
};
